module.exports = __webpack_public_path__ + "static/media/ehealth_personal_folder_banner_desktop.ab6a3074.jpg";